import { render, staticRenderFns } from "./Persistence.vue?vue&type=template&id=4125051d"
import script from "./Persistence.vue?vue&type=script&lang=js"
export * from "./Persistence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports